import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import BaseComponent from "../../base-component";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {galleryDestroy, galleryLoad, galleryUpload} from "../../../gallery/gallery-actions";
import {FormattedMessage, injectIntl} from "react-intl";
import {Formik} from "formik";
import BootstrapPagination from "../../bootstrap-pagination";
import BootstrapTableSize from "../../bootstrap-table-size";
import {destroyResource, handleApiResponse} from "../../../crud-actions";
import ButtonGroup from "reactstrap/es/ButtonGroup";
import Loading from "../../loading";
import Notifications from "./notifications";

class GalleryItemList extends BaseComponent {

    constructor(params) {
        super(params);

        this.state = {
            notifications: []
        }
    }

    componentDidMount() {
        if (this.props.active) {
            this.fetch({q: {}});
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.active && !prevProps.active) {
            this.fetch({q: {}});
        }
    }

    fetch = (filter = { q: {} }) => {
        const itemFilter = this.props.itemFilter;
        if (itemFilter) filter['q']['type_eq'] = itemFilter;

        return this.props.galleryLoad(filter);
    };

    destroyItem(id) {
        const { galleryDestroy, intl } = this.props;

        const promise = galleryDestroy(id);
        handleApiResponse(
            'GALLERY',
            'DESTROY',
            promise,
            (response) => {
                this.fetch({q: {}});
                // this.setState({notifications: [{type:'success', text: intl.formatMessage({id: 'app.gallery.messages.destroy.success'}) }]});
            },
            (result) => {
                let errors = result.payload.response.errors;
                form.setErrors(errors);
                this.fetch({q: {}});
            },
            (error) => {
                console.log(error);
                // this.setState({notifications: [{type:'danger', text: intl.formatMessage({id: 'app.gallery.messages.destroy.fail'}) }]});
            });
    }

    updateFilter = (values, form) => {
        let currentFilter = this.props.gallery.filter || {};
        let newFilter = { q: values };
        if (currentFilter['per']) newFilter['per'] = currentFilter['per'];
        this.fetch(newFilter).then(() => { form.setSubmitting(false); });
    };

    render() {
        const { gallery } = this.props;
        return (
            <div className='mt-3'>
                <Notifications notifications={this.state.notifications} />
                <Formik
                    onSubmit={this.updateFilter}
                    initialValues={{ name_cont: '' }}
                    render={props => (
                        <form onSubmit={(event) => { event.stopPropagation(); props.handleSubmit(event); }}>
                            <div className='form-group'>
                                <label><FormattedMessage id='app.gallery_items.attribute.name'/></label>
                                <input type='text' id='name_cont' className='form-control' value={props.values.name_cont} onChange={props.handleChange}/>
                            </div>
                            <button type='submit' className='btn btn-primary'><FontAwesomeIcon icon={['far', 'filter']}/></button>
                        </form>
                    )}
                />
                <hr/>
                {   gallery.loading && <Loading/> }
                {   !gallery.loading &&
                gallery.list.map((item) => {
                    return (
                        <div className='row mb-3' key={item.id}>
                            <div className='col-9'>
                                <p><strong>{ item.name }</strong><br/>{ item.filename }</p>
                                <p>{ item.alt }</p>
                                <p>{ item.description }</p>
                                <ButtonGroup>
                                    <button className='btn btn-primary' onClick={() => { this.props.addItem(item) }}><FontAwesomeIcon icon={['far', 'paste']}/></button>
                                    <button className='btn btn-secondary' onClick={() => { this.destroyItem(item.id) }}><FontAwesomeIcon icon={['far', 'trash']}/></button>
                                </ButtonGroup>
                            </div>
                            <div className='col-3'>
                                <img alt={ item.alt } src={item.preview}/>
                            </div>
                        </div>
                    );
                })
                }
                <hr/>
                <p><FormattedMessage id='app.table.total' values={{count: gallery.total_count}}/></p>
                <BootstrapPagination totalPages={gallery.total_pages} currentPage={gallery.current_page} filter={gallery.filter} fetch={this.fetch}/>
                <BootstrapTableSize limitValue={gallery.limit_value} filter={gallery.filter} fetch={this.fetch}/>
            </div>

        );
    }

}

function mapStateToProps(state,ownProps) {
    return {
        gallery: state.gallery
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        galleryLoad: galleryLoad,
        galleryUpload: galleryUpload,
        galleryDestroy: galleryDestroy
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, matchDispatchToProps)(GalleryItemList));
